import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class WildcardRedirectGuard implements CanActivate {
  constructor(
    private fireAuth: AngularFireAuth,
    private router: Router,
    public navCtrl: NavController,

  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.fireAuth.authState.pipe(
      take(1),
      switchMap(async (authState) => {

        // check if user is logged in


        // not logged in? navigate to login page
        if (!authState) {
          this.router.navigate(['/home']); // Redirect to 'home' otherwise
          return false;
        }

        this.router.navigate(['/app']); // Redirect to 'main' if logged in
        return true;
      })
    );
  }
}
